import { IEntityWithStatus, EntityWithStatus } from "./EntityWithStatus";

export interface IZCoreLocation extends IEntityWithStatus {
    CustomerID?: number;
    Address1: string | null;
    Address2: string | null;
    City: string | null;
    StateRegion: string | null;
    ZipPostcode: string | null;
    Country: string | null;
    Switchboard: string | null;
}

export class ZCoreLocation extends EntityWithStatus implements IZCoreLocation {
    public CustomerID = null;
    public Address1 = null;
    public Address2 = null;
    public City = null;
    public StateRegion = null;
    public ZipPostcode = null;
    public Country = null;
    public Switchboard = null;
}